"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_jss_1 = __importDefault(require("react-jss"));

var PluginElements_1 = __importDefault(require("../../components/PluginElements"));

var HistoryPluginElements = PluginElements_1.default;
var styles = {
  container: {
    display: 'flex',
    background: '#d9d9d9',
    padding: 6,
    borderRadius: 12,
    margin: '4px 0',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  address: {
    fontFamily: 'monospace',
    margin: '0 4px'
  },
  value: {
    whiteSpace: 'nowrap'
  },
  details: {
    flex: '1 0',
    overflow: 'hidden'
  },
  mainDetail: {
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  type: {
    minWidth: 64,
    fontSize: 18,
    marginRight: 12
  },
  subDetail: {
    fontSize: 14
  }
};

var HistoryListEvent = function HistoryListEvent(_a) {
  var event = _a.event,
      account = _a.account,
      classes = _a.classes,
      navigateTo = _a.navigateTo;
  var asset = event.getAsset();

  if (!asset) {
    console.warn("Could not find asset " + event.asset);
    return null;
  }

  var type;
  var main;
  var onClick;
  var subDetail = null;

  switch (event.type) {
    case 'send':
      var isReceive = event.to === account;
      type = isReceive ? 'Receive' : 'Send';
      main = react_1.default.createElement(react_1.Fragment, null, isReceive ? 'From: ' : 'To: ', react_1.default.createElement("span", {
        className: classes.address,
        title: isReceive ? event.from : event.to
      }, isReceive ? event.from : event.to));

      if (event.message && event.message.length > 0) {
        subDetail = event.message;
      }

      onClick = function onClick() {
        return navigateTo("/receipt/" + asset.id + "/" + event.tx);
      };

      break;

    case 'exchange':
      type = 'Exchange';
      break;

    default:
      console.warn('Unknown event type', event.type);
  }

  return react_1.default.createElement("div", {
    className: classes.container,
    onClick: onClick
  }, react_1.default.createElement("div", {
    className: classes.type
  }, type), react_1.default.createElement("div", {
    className: classes.details
  }, react_1.default.createElement("div", {
    className: classes.mainDetail
  }, main), subDetail && react_1.default.createElement("div", {
    className: classes.subDetail
  }, subDetail)), react_1.default.createElement("div", {
    className: classes.value
  }, asset.getDisplayValue(event.value), " ", asset.name), react_1.default.createElement(HistoryPluginElements, {
    position: "history-event",
    event: event
  }));
};

exports.default = react_jss_1.default(styles)(HistoryListEvent);